// Subpath entry for the shared registration flow logic:
// `@galapagos/shared/registration`. Pure, platform-free flow rules consumed by
// both the mobile and web registration surfaces; kept off the top barrel so
// the flow vocabulary stays an explicit import at every use site.
export * from './src/registration';
